import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import { themeGet } from '@primer/react';
import LTCounterLabel from '../LTCounterLabel/index.js';
import LTPopover from '../LTPopover/index.js';
import LTTag from '../LTTags/index.js';
import LTTooltip from '../LTTooltip/index.js';
import styled from 'styled-components';

var TagList = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style-type: none;\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  padding: 0px;\n  margin: 0px;\n  @media only screen and (max-width: 1024px) {\n    flex-wrap: wrap;\n  }\n"], ["\n  list-style-type: none;\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  padding: 0px;\n  margin: 0px;\n  @media only screen and (max-width: 1024px) {\n    flex-wrap: wrap;\n  }\n"])), themeGet("space.2"));
var Tag = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  justify-content: center;\n  &:hover {\n    cursor: ", "};\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  justify-content: center;\n  &:hover {\n    cursor: ", "};\n  }\n"])), themeGet("space.2"), function (_a) {
  var clickable = _a.clickable;
  return clickable ? "pointer" : "default";
});
var PopOverContent = styled.ul(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  gap: ", ";\n  align-items: start;\n  padding: 0px;\n  flex-direction: column;\n"], ["\n  display: flex;\n  gap: ", ";\n  align-items: start;\n  padding: 0px;\n  flex-direction: column;\n"])), themeGet("space.2"));
var ToolTipTag = function ToolTipTag(_a) {
  var tags = _a.tags,
    totalCount = _a.totalCount,
    onClick = _a.onClick,
    inlineTagCount = _a.inlineTagCount;
  return /*#__PURE__*/React.createElement(PopOverContent, null, tags.slice(inlineTagCount, totalCount).map(function (tag, index) {
    var _a = tag || {},
      _b = _a.name,
      name = _b === void 0 ? "" : _b,
      tag_id = _a.tag_id;
    var isClickable = typeof onClick === 'function';
    return /*#__PURE__*/React.createElement(Tag, {
      key: tag_id,
      id: "tag-".concat(tag_id),
      clickable: isClickable
    }, /*#__PURE__*/React.createElement(LTTooltip, {
      text: name,
      key: "".concat(name, "-").concat(index)
    }, /*#__PURE__*/React.createElement(LTTag, {
      text: name,
      variant: LTTag.Variant.SECONDARY,
      clickHandler: function clickHandler() {
        return isClickable ? onClick(tag_id) : function () {};
      },
      clickable: isClickable
    })));
  }));
};
var LTTagGroup = function LTTagGroup(_a) {
  var _b = _a.tags,
    tags = _b === void 0 ? [] : _b,
    _c = _a.inlineTagCount,
    inlineTagCount = _c === void 0 ? 2 : _c,
    onClick = _a.onClick;
  var totalTags = tags.length;
  var remainingTagCount = totalTags - inlineTagCount;
  if (!totalTags) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(TagList, {
    id: "tagList"
  }, tags.slice(0, inlineTagCount).map(function (tag) {
    var _a = tag || {},
      _b = _a.name,
      name = _b === void 0 ? "" : _b,
      tag_id = _a.tag_id;
    return /*#__PURE__*/React.createElement(Tag, {
      key: tag_id,
      id: "tag-".concat(tag_id),
      clickable: typeof onClick === 'function'
    }, /*#__PURE__*/React.createElement(LTTooltip, {
      text: name,
      key: tag_id
    }, /*#__PURE__*/React.createElement(LTTag, {
      text: "".concat(name),
      variant: LTTag.Variant.SECONDARY,
      clickable: typeof onClick === 'function',
      clickHandler: function clickHandler() {
        return typeof onClick === 'function' ? onClick(tag_id) : function () {};
      }
    })));
  })), remainingTagCount > 0 && /*#__PURE__*/React.createElement(LTPopover, {
    popoverConfig: {
      "aria-labelledby": "tag-details"
    },
    usePortal: true,
    text: /*#__PURE__*/React.createElement(ToolTipTag, {
      totalCount: totalTags,
      tags: tags,
      onClick: onClick,
      inlineTagCount: inlineTagCount
    })
  }, /*#__PURE__*/React.createElement(LTCounterLabel, {
    count: "+".concat(remainingTagCount),
    scheme: LTCounterLabel.Scheme.OUTLINED
  })));
};
var templateObject_1, templateObject_2, templateObject_3;

export { LTTagGroup as default };
